module.exports = __webpack_public_path__ + "static/media/bell.1bdd511a.svg";